// Shared UI style tokens — larger, readable, responsive

export const glassCard = {
  background: 'var(--card-grad)',
  border: '1px solid rgba(255,255,255,0.09)',
  borderRadius: '18px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.06)',
  backdropFilter: 'blur(14px)',
};

export const pageBg = {
  minHeight: '100vh',
  background: 'radial-gradient(ellipse 80% 50% at 80% -5%, var(--accent-glow, rgba(200,90,20,0.2)) 0%, transparent 55%), var(--bg, #131216)',
};

// table cells — bigger
export const cell = { padding: '14px 18px', fontFamily: 'ui-monospace, "JetBrains Mono", monospace', fontSize: '15px', textAlign: 'right' };
export const th = { ...cell, color: 'var(--text-dim)', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: 600, fontFamily: "'Inter', sans-serif" };
export const labelCell = { ...cell, textAlign: 'left', fontFamily: "'Inter', sans-serif", fontSize: '16px' };

export const sectionTitle = { fontSize: '18px', fontWeight: 600, color: 'var(--text)', fontFamily: "'Space Grotesk', sans-serif" };
export const sectionSub = { fontSize: '14px', color: 'var(--text-mute)', marginLeft: '12px' };

export const editInput = {
  background: 'rgba(249,115,22,0.15)', border: '1px solid rgba(249,115,22,0.45)', borderRadius: '6px',
  color: '#fb923c', fontFamily: 'monospace', fontSize: '15px', padding: '5px 8px', outline: 'none', textAlign: 'right',
};
